module.exports = __webpack_public_path__ + "img/zold_marketing.a73ec20a.png";